import $ from "jquery";

$(function () {
  // ジョブカードのshadow
  $(".job-card").hover(
    function () {
      $(this).addClass("shadow").css("cursor", "pointer");
    },
    function () {
      $(this).removeClass("shadow");
    }
  );
});
